import Glide, {Controls} from '@glidejs/glide/dist/glide.modular.esm';

export class Carousel extends HTMLElement {
  #glide = null;

  constructor() {
    super();
    this.#glide = new Glide(this, {
      type: 'slider',
      startAt: 0,
      perView: 1,
      gap: 0,
      rewind: true,
    });
  }

  connectedCallback() {
    this.classList.add('glide');

    this.#glide.on('mount.after', this.#handleGlideRunAfter);
    this.#glide.on('run.after', this.#handleGlideRunAfter);

    requestAnimationFrame(() => this.#glide.mount({Controls}));
  }

  disconnectedCallback() {
    this.classList.remove('glide');
    this.#glide.destroy();
  }

  #handleGlideRunAfter = () => {
    this.dispatchEvent(new CustomEvent('via-carousel:update', {
      detail: {
        index: this.#glide.index,
        total: this.querySelectorAll('via-carousel-item').length,
      },
    }));
  }

}